/**
 * Standard-format date strings
 */

/**  Environment  */
import environmentVariables from '../util/environmentVariables';
environmentVariables();

/**  Imports  */
import moment from 'moment';

/**  Globals  */
const ONE_WEEK_IN_MS = 1000 * 60 * 60 * 24 * 7;

/**  Method  */
export default function dateString(input_date: string | number | Date): string {
    const now = moment();
    const date = moment(input_date);
    const dt = now.diff(date);

    /**
     * If not in the same year, return year on the format : "Apr. 24, 2017"
     * Else if beyond a week ago, or in future in the same year : "Apr. 24"
     * Else if within last week : "x ago"
     */
    if (!date.isSame(now, 'year')) {
        return date.format('MMM D, YYYY');
    } else if (dt > ONE_WEEK_IN_MS || dt < 0) {
        return date.format('MMM D');
    } else {
        return date.from(now);
    }
}
